import { Section } from 'react-scale/components';
import Card from '../common/card';

const stats = [
  { data: '120+', label: 'Speakers' },
  { data: '80+', label: 'Sessions' },
  { data: '20,000+', label: 'Attendees' },
  { data: '5', label: 'Tracks' }
];

const Stat = ({ data, label }) => (
  <div className="text-center">
    <p className="inline-block text-5xl text-transform-x-gradient font-aeonik">{data}</p>
    <p className="text-sm tracking-[4px] uppercase">{label}</p>
  </div>
);

const TransformXStatsBar = () => (
  <Section id="stats" paddingBottom={false}>
    <Card className="flex flex-col justify-around py-8 space-y-8 lg:space-y-0 lg:flex-row">
      {stats.map(stat => (
        <div key={stat.label}>
          <Stat {...stat} />
        </div>
      ))}
    </Card>
  </Section>
);

export default TransformXStatsBar;
